import React, { useContext, useState } from "react";
import { useMutation } from "@apollo/client";
//Import from project
import { AuthContext } from "../../../Context/AuthContext";
import { DELETE_EXPENSE_TYPE } from "../../../Schema/Expense";

const useDeleteExpenseType = ({ handleClose, setRefetch, id }) => {
  // Change Language
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const [deleteExpenseType] = useMutation(DELETE_EXPENSE_TYPE, {
    onCompleted: ({ deleteExpenseType }) => {
      setLoading(false);
      if (deleteExpenseType?.isSuccess === true) {
        setAlert(true, "success", deleteExpenseType?.message);
        handleClose();
        setRefetch();
      } else {
        setAlert(true, "error", deleteExpenseType?.message);
      }
    },
    onError: ({ message }) => {
      setLoading(false);
      setAlert(true, "error", { messageKh: message, messageEn: message });
    },
  });

  const handleDelete = () => {
    setLoading(true);
    deleteExpenseType({
      variables: {
        id: id,
      },
    });
  };

  return { deleteExpenseType, loading, setLoading, handleDelete };
};

export default useDeleteExpenseType;
